// Establishes the split-test session context (variant id + label + session id)
// and records the page_view for directly-servable variant routes such as /lp-b.
//
// /apply does this as part of weighted assignment. Without it, a visitor who
// lands straight on /lp-b has no variant context, so cta_click / survey_start /
// survey_complete are dropped and the GHL LP-<variant> tag is missing.
import { useEffect } from "react";
import {
  getVisitorId,
  isInternalTraffic,
  SESSION_ID_KEY,
  VARIANT_ID_KEY,
} from "@/lib/analytics";

export function useVariantSession(
  label: "A" | "B" | "C" | "D",
  path: string,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      try {
        const sessionId =
          sessionStorage.getItem(SESSION_ID_KEY) ?? crypto.randomUUID();
        sessionStorage.setItem(SESSION_ID_KEY, sessionId);
        const { assignVariantAndTrackView } = await import(
          "@/lib/variant-assign.functions"
        );
        const res = await assignVariantAndTrackView({
          data: {
            session_id: sessionId,
            visitor_id: getVisitorId(),
            existing_variant_id: null,
            path,
            preview: isInternalTraffic(),
            force_label: label,
          },
        });
        if (cancelled) return;
        if (res.variant_id) {
          sessionStorage.setItem(VARIANT_ID_KEY, res.variant_id);
          sessionStorage.setItem("inflow_variant_label", res.variant_label);
        }
      } catch (e) {
        console.error("[lp] variant session setup failed", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [label, path, enabled]);
}
